import { SvgIconComponent } from "@mui/icons-material";
import { IconButton, Tooltip, useTheme } from "@mui/material";

interface IFeedbackButton {
  onClick?: () => void;
  visibility?: boolean;
  tooltipTitle?: string;
  disabled?: boolean;
  primary?: boolean;
  Icon: SvgIconComponent;
}
export const FeedbackButton = (props: IFeedbackButton) => {
  const { onClick, visibility, tooltipTitle, disabled, primary, Icon } = props;
  const theme = useTheme();

  return (
    <Tooltip title={tooltipTitle}>
      <span>
        <IconButton
          disabled={disabled}
          sx={{
            zIndex: 10,
            p: 1,
            justifyContent: "center",
            alignItems: "center",
            visibility: visibility ? "hidden" : "visible",
            background: disabled ? theme.palette.grey[100] : "transparent",
            color: primary ? "#4caf50" : theme.palette.error.main,
            "&.Mui-disabled": {
              color: primary ? "#4caf50" : theme.palette.error.main,
              background: theme.palette.grey[100],
            },
          }}
          onClick={onClick}
        >
          <Icon sx={{ width: "18px", height: "18px", display: "flex" }} />
        </IconButton>
      </span>
    </Tooltip>
  );
};
